import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { reportService } from "@services/ReportServices";
import { toastService } from "@services/ToastService";
export const useReport = () => {
  const navigate = useNavigate();
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generateReportDirect = async (
    projectId: string,
    reportName: string,
    templateId: number,
    checkedItems: any
  ) => {
    try {
      const response = await reportService.generateReportDirect(
        projectId,
        templateId,
        reportName,
        checkedItems
      );
      return response;
    } catch (err) {
      console.error("Error generating report:", err);
      throw err;
    }
  };

  const exportReport = async (
    projectId: string,
    reportId: string,
    html: string
  ) => {
    try {
      const response = await reportService.exportReport(
        projectId,
        html,
        reportId
      );
      return response;
    } catch (err) {
      console.error("Error exporting report:", err);
      throw err;
    }
  };

  const fetchReportMembers = async (projectId: string, reportId: string) => {
    try {
      const data = await reportService.getReportMembers(projectId, reportId);
      return data || [];
    } catch (err) {
      console.error("Error fetching members:", err);
      return [];
    }
  };
  const deleteReport = async (projectId: string, reportId: string) => {
    try {
      await reportService.deleteReport(projectId, reportId);
      toastService.success("Report deleted");
    } catch (err) {
      console.error("Failed to delete report:", err);
      throw err;
    }
  };
  const getReport = async (
    projectId: string,
    reportId: string,
    sharedToken?: string
  ) => {
    try {
      const data = await reportService.getReport(
        projectId,
        reportId,
        sharedToken
      );
      return data;
    } catch (err) {
      console.error("Error fetching report1:", err);
      throw err;
    }
  };
  const getReportsDropdown = async (
    projectId: string,
    sharedToken?: string
  ) => {
    try {
      const response = await reportService.getReportsDropdown(
        projectId,
        sharedToken
      );
      return response || [];
    } catch (err) {
      console.error("Error fetching reports:", err);
      throw err;
    }
  };
  const getReportById = async (projectId: string, reportId: number) => {
    try {
      const response = await reportService.getReportById(projectId, reportId);
      return response;
    } catch (err) {
      console.error("Error fetching report2:", err);
      throw err;
    }
  };
  const updateReport = async (
    projectId: string,
    reportId: string,
    payload: any
  ) => {
    try {
      const response = await reportService.updateReport(
        projectId,
        reportId,
        payload
      );
      toastService.success("Report updated successfully");
      return response?.data;
    } catch (err) {
      console.error("Error updating report:", err);
      throw err;
    }
  };
  const getPublicReport = async (reportId: string) => {
    try {
      const data = await reportService.getPublicReport(reportId);
      return data;
    } catch (err) {
      console.error("Error fetching public report:", err);
      throw err;
    }
  };

  const getReports = async (
    projectId: string,
    params?: { order?: string; offset?: number; limit?: number },
    sharedToken?: string
  ) => {
    try {
      const response = await reportService.getReports(
        projectId,
        params,
        sharedToken
      );
      return response || [];
    } catch (err) {
      console.error("Error fetching reports:", err);
      throw err;
    }
  };

  const grantReportRole = async (
    projectId: string,
    reportId: string,
    email: string,
    roleId: number
  ) => {
    try {
      const response = await reportService.grantRole(
        projectId,
        reportId,
        email,
        roleId
      );
      return response;
    } catch (error) {
      console.error("Error granting report role:", error);
      return false;
    }
  };
  const revokeReportRole = async (
    projectId: string,
    reportId: string,
    memberId: number
  ) => {
    try {
      await reportService.revokeRole(projectId, reportId, memberId);
    } catch (err) {
      console.error("Failed to revoke report role:", err);
      throw err;
    }
  };

  const toggleReportPublicAccess = async (
    projectId: string,
    reportId: string,
    isPublic: boolean
  ) => {
    try {
      const res = await reportService.toggleReportPublicAccess(
        projectId,
        reportId,
        isPublic
      );
      return res?.status === 200;
    } catch (err) {
      console.error("Failed to update report public access:", err);
      return false;
    }
  };

  const publishReport = async (
    projectId: string,
    reportId: string,
    isPublished: boolean
  ): Promise<boolean> => {
    try {
      const res = await reportService.publishReport(
        projectId,
        reportId,
        isPublished
      );
      return res?.status === 200;
    } catch (err) {
      console.error("Failed to update report published state:", err);
      return false;
    }
  };

  return {
    generateReportDirect,
    exportReport,
    fetchReportMembers,
    deleteReport,
    isGenerating,
    error,
    getReport,
    getReportById,
    updateReport,
    getPublicReport,
    getReports,
    grantReportRole,
    revokeReportRole,
    toggleReportPublicAccess,
    getReportsDropdown,
    publishReport,
  };
};
